<template>
  <g>
    <path
      d="M17 16.0002C16.45 16.0002 16 15.5502 16 15.0002H8C8 15.5502 7.55 16.0002 7 16.0002C6.45 16.0002 6 15.5502 6 15.0002H2V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V15.0002H18C18 15.5502 17.55 16.0002 17 16.0002Z"
    />
    <path
      d="M20 8.00018H17V6.00018C17 4.90018 16.1 4.00018 15 4.00018H9C7.9 4.00018 7 4.90018 7 6.00018V8.00018H4C2.9 8.00018 2 8.90018 2 10.0002V14.0002H6V13.0002C6 12.4502 6.45 12.0002 7 12.0002C7.55 12.0002 8 12.4502 8 13.0002V14.0002H16V13.0002C16 12.4502 16.45 12.0002 17 12.0002C17.55 12.0002 18 12.4502 18 13.0002V14.0002H22V10.0002C22 8.90018 21.1 8.00018 20 8.00018ZM15 8.00018H9V6.00018H15V8.00018Z"
    />
  </g>
</template>
